
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}


// 是否登录
export const setloginType = value => {
  return {
    type: 'SETLOGINTYPE',
    value
  }
}

// 首页弹窗
export const setPopType = value => {
  return {
    type: 'SETPOPTYPE',
    value
  }
}

// 放大图片
export const setFullImg = data => {
  return {
    type: 'SETFULLIMG',
    data
  }
}

// 全局loading
export const setLoadingPop = value => {
  return {
    type: 'SETLOADINGPOP',
    value
  }
}

// 声音弹窗
export const updateVoiceModalVisible = value => {
  return {
    type: 'UPDATEVOICEMODALVISIBLE',
    value
  }
}

// 声音开关
export const updateVoice = (key, value) => {
  return {
    type: 'UPDATEVOICE',
    key,
    value
  }
}